// extracted by mini-css-extract-plugin
export default {"birthday":"Birthday__birthday___zud1q"};